import { render, staticRenderFns } from "./FormPanel.vue?vue&type=template&id=050ab6a8&scoped=true"
import script from "./FormPanel.vue?vue&type=script&lang=js"
export * from "./FormPanel.vue?vue&type=script&lang=js"
import style0 from "./FormPanel.vue?vue&type=style&index=0&id=050ab6a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050ab6a8",
  null
  
)

export default component.exports